import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusIconCompleted, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type AssetTaggingTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type AssetTaggingTaskCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<AssetTaggingTask>;
  onClear: () => void;
};

export const AssetTaggingTaskCompletedPanelItem = memo(
  ({ metadata: { addedTags = [], removedTags = [] }, onClear }: AssetTaggingTaskCompletedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const tagCount = addedTags.length + removedTags.length;

    return (
      <PaneItemTW
        avatar={<FileStatusIconCompleted size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="ASSET_TAGGING_TASK_COMPLETED_PANEL_ITEM_TITLE">Tags updated</FileStatusTitle>
        }
        subtitle={
          tagCount > 0 ? (
            <span className="ads:text-secondary text-12 text-gray-11">
              {addedTags.length > 0 && `${addedTags.length} ${pluralize('tag', addedTags.length)} added`}
              {addedTags.length > 0 && removedTags.length > 0 && ', '}
              {removedTags.length > 0 && `${removedTags.length} ${pluralize('tag', removedTags.length)} removed`}
            </span>
          ) : undefined
        }
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

AssetTaggingTaskCompletedPanelItem.displayName = 'AssetTaggingTaskCompletedPanelItem';
